import { useState } from "react";

export const useFilePicker = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
  };

  return { selectedFile, handleFileSelect };
};
